<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">

        <div class="dialog-input-item">
          <label>收支类型</label>
          <el-select v-model="detailType" placeholder="Select" class="select-item" @change="detailTypechange">
            <el-option v-for="item in detailTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>账单名称</label>
          <el-select v-model="type" placeholder="Select" class="select-item">
            <el-option v-for="item in typeArray" :key="item.type" :label="item.name" :value="item.type">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
<!--        <div class="dialog-input-item">-->
<!--          <label>负责人</label>-->
<!--          <el-input type="text" v-model="searchValue" placeholder="请输入负责人" class="select-item"  clearable>-->
<!--            <template #prefix>-->
<!--              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>-->
<!--            </template>-->
<!--          </el-input>-->
<!--        </div>-->
      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons  type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
        <div class="dialog-input-btn">
<!--          <ElButtons  type="danger" icon="Wallet"  @click="openDialog"> 充值 </ElButtons>-->
        </div>
      </div>
    </div>
    <div style="margin-bottom: 16px;">
      <el-button type="primary" @click="editMedicalDialog(-1, {}, 5)">赠送</el-button>
      <el-button type="warning" @click="editMedicalDialog(-1, {}, -1)">扣除</el-button>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        @cell-click="toggleSelection"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="时间"/>
      <el-table-column property="shopName" label="门店"/>
      <el-table-column property="content" label="收支类型">
        <template #default="scope">
          {{scope.row.type > 0?'收入':'支出'}}
        </template>
      </el-table-column>
      <el-table-column property="typeName" label="账单名称" />
      <el-table-column property="money" label="医疗金金额">
        <template #default="scope">
          <span>{{scope.row.type < 0 && scope.row.money > 0?'-':''}}{{scope.row.money}}</span>
        </template>
      </el-table-column>
      <el-table-column property="relationAdminName" label="图片凭证">
        <template #default="scope">
          <div v-if="scope.row.type == -1 || scope.row.type == 5">
            <div v-if="scope.row.imgList.length > 0" class="cursor" @click="userImgList(scope.row)">
              <el-image class="item-img" fit="fill" :src="scope.row.imgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div v-else>
              <el-image class="item-img" fit="fill"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="adminName" label="添加人" />
      <el-table-column property="remark" label="备注" class-name="cursor"/>
      <el-table-column property="" label="操作">
        <template #default="scope">
          <el-button v-if="scope.row.type == -1 || scope.row.type == 5" type="primary" size="small" @click="editMedicalDialog(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {listMedicalBenefitType, getMedicalBenefitPageList} from '@/api/url';
import DatePickerRange from "@/components/DatePickerRange";
import Dialog from "@/assets/js/dialog";
import medicalRemarkDialog from "@/views/user/components/medical/medicalRemarkDialog";
import UserDialog from "@/views/user/components/UserDialog";
import editMedicalDialog from "@/views/user/components/medical/editMedicalDialog";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange},
  data() {
    return {
      pageDataList: [],
      userId: this.value.userId,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      searchValue: '',
      searchType: 1,

      detailType: -1,
      detailTypeArray: [
        {label: '不限', value: -1},
        {label: '收入', value: 0},
        {label: '支出', value: 1},
      ],

      type: 0,
      typeArray: [
        {name: '不限', type: 0},
      ],
      typeList: [],

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

    }
  },
  methods: {

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.imgList,
          id: row.id,
          width: 908,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userId;
      param['detailType'] = this.detailType;
      param['type'] = this.type;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      // param['searchType'] = this.searchType;
      // param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMedicalBenefitPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          if(this.pageDataList.length > 3) {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList.slice(0,3)));
          } else {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList));
          }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getTypeList() {
      getFormData(listMedicalBenefitType).then(data=> {
        this.typeList = data.data
        this.typeArray = [...this.typeArray, ...this.typeList]
      })
    },

    detailTypechange() {
      this.typeArray = [
        {name: '不限', type: -1},
      ]
      this.type = 0
      if(this.detailType == -1) {
        this.typeArray = [...this.typeArray, ...this.typeList]
      }else if(this.detailType == 0) {
        let arr = this.typeList.filter(item => item.type > 0)
        this.typeArray = [...this.typeArray, ...arr]
      }else if(this.detailType == 1) {
        // let arr = this.typeList.filter(item => item.type < 0)
        this.typeArray = [...this.typeArray]
      }
    },

    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if (column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '医疗金备注',
          component: medicalRemarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          confirm: (result) => {
            row.remark = result.remark
          }
        })
      }

    },

    editMedicalDialog(idx, row, type) {
      let _title = '';
      let medicalForm = {}
      if (idx > -1) {
        _title = '医疗金'
        medicalForm = Object.assign({}, row);
        // console.log(userForm)
      }else {
        _title = '医疗金'
        medicalForm.type = type
        // console.log(userForm)
      }
      Dialog.open({
        title: _title,
        component: editMedicalDialog,
        data: {
          medicalForm: JSON.stringify(medicalForm),
          userId: this.userId,
          ids: idx,
          width: '700px',
        },
        confirm: (result) => {
          this.getPage()
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },

  },
  mounted() {
    this.getTypeList()
    this.getPage();
    // this.getUserInfo()
  }
}
</script>

<style>
.item-img {
  width: 80px;
  height: 80px;
}

</style>
